import React, { Fragment } from 'react';
import { Col } from 'reactstrap';
import { UL } from '../../../AbstractElements';
import Searchbar from './Searchbar';
import UserHeader from './UserHeader';
import HeaderLogout from './HeaderLogout';
import Notificationbar from './Notificationbar';
import { useGetNotifications } from '../../../queries';
const RightHeader = () => {
  const { data, loading, error } = useGetNotifications();

  return (
    <Fragment>
      <Col xxl='7' xl='6' md='7' className='nav-right pull-right right-header col-8 p-0 ms-auto'>
        {/* <Col md="8"> */}
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
          {/* <Language /> */}
          <Searchbar />
          {/* <BookmarkHeader />*/}
          {/* <MoonLight /> */}
          {/*<CartHeader />*/}
           <Notificationbar data={data} loading={loading} error={error} />
          <UserHeader />
          <HeaderLogout />
        </UL>
        {/* </Col> */}
      </Col>
    </Fragment>
  );
};

export default RightHeader;